import React from "react";

export const markdownComponents = {
  p: ({ node, ...props }: any) => <p className="my-3" {...props} />,
  h1: ({ node, ...props }: any) => (
    <h1 className="text-2xl font-bold mt-6 mb-3 first:mt-0" {...props} />
  ),
  h2: ({ node, ...props }: any) => (
    <h2 className="text-xl font-bold mt-5 mb-3 first:mt-0" {...props} />
  ),
  h3: ({ node, ...props }: any) => (
    <h3 className="text-lg font-semibold mt-4 mb-2 first:mt-0" {...props} />
  ),
  h4: ({ node, ...props }: any) => (
    <h4 className="text-base font-semibold mt-3 mb-2 first:mt-0" {...props} />
  ),
  h5: ({ node, ...props }: any) => (
    <h5 className="text-sm font-semibold mt-3 mb-2 first:mt-0" {...props} />
  ),
  h6: ({ node, ...props }: any) => (
    <h6 className="text-sm font-medium mt-3 mb-2 first:mt-0" {...props} />
  ),
  pre: ({ node, ...props }: any) => (
    <pre className="p-4 rounded-md overflow-x-auto my-4" {...props} />
  ),
  code: ({ node, className, ...props }: any) => {
    const isInline = node?.tagName === "code" && node?.children.length === 1;
    return isInline ? (
      <code className="px-1 py-0.5 rounded bg-zinc-800 text-white" {...props} />
    ) : (
      <pre className="p-2 rounded block overflow-x-auto bg-zinc-800 text-white">
        <code {...props} />
      </pre>
    );
  },
  blockquote: ({ node, ...props }: any) => (
    <blockquote className="border-l-4 border-blue-500 pl-4 text-gray-600 my-4" {...props} />
  ),
  a: ({ node, ...props }: any) => (
    <a className="text-emerald-400 underline" {...props} />
  ),
  ul: ({ node, ...props }: any) => <ul className="list-disc pl-5 my-3 space-y-1" {...props} />,
  ol: ({ node, ...props }: any) => <ol className="list-decimal pl-5 my-3 space-y-1" {...props} />,
  li: ({ node, ...props }: any) => <li className="my-1" {...props} />,
  table: ({ node, ...props }: any) => (
    <table className="table-auto border-collapse border border-gray-300 w-full my-4" {...props} />
  ),
  th: ({ node, ...props }: any) => (
    <th className="border border-zinc-700 bg-zinc-800 p-2 text-left text-zinc-100" {...props} />
  ),
  td: ({ node, ...props }: any) => (
    <td className="border border-zinc-700 p-2 text-zinc-200" {...props} />
  ),
};